import {client} from "../client";

const rodizioService = {
    getFiltros() {
        return client.get('rodizios/filtros');
    },

    pegarRodizioPorAno(ano) {
        return client.get(`rodizios/pegarPorAno/${ano}`);
    },

    getRodizio(filialSlug, ano) {
        return client.get(`rodizios/getRodizio/${filialSlug}/${ano}`);
    },

    getYears(filialSlug) {
        return client.get(`rodizios/getAnos/${filialSlug}`);
    }

}

export {
    rodizioService
}
